import React, { useState } from 'react';
import { Settings as SettingsIcon, Shield, Bell, Key, Database, Check } from 'lucide-react';

export default function Settings() {
  const [workspaceName, setWorkspaceName] = useState('NexusFlow Enterprise');
  const [apiKey, setApiKey] = useState('nx_live_99f83a2bc71e409d8821a');
  const [saved, setSaved] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  return (
    <div className="p-8 space-y-8 animate-fadeIn max-w-4xl">
      <div className="space-y-2">
        <h1 className="text-2xl font-extrabold text-slate-900">Workspace Settings & Security</h1>
        <p className="text-sm text-slate-500">Configure your organization preferences, API keys, and notification channels.</p>
      </div>

      <form onSubmit={handleSave} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 space-y-6">
        <h2 className="text-base font-bold text-slate-900 border-b border-slate-100 pb-4 flex items-center gap-2">
          <SettingsIcon className="w-5 h-5 text-indigo-600" /> General Settings
        </h2>

        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-slate-600 uppercase mb-1">Workspace Name</label>
            <input 
              type="text"
              value={workspaceName}
              onChange={(e) => setWorkspaceName(e.target.value)}
              className="w-full text-sm bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-slate-600 uppercase mb-1">Enterprise API Key</label>
            <div className="flex gap-2">
              <input 
                type="password"
                readOnly
                value={apiKey}
                className="flex-1 text-sm bg-slate-50 border border-slate-200 rounded-xl px-4 py-2.5 font-mono text-slate-600"
              />
              <button 
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(apiKey);
                  alert('API Key copied to clipboard!');
                }}
                className="px-4 py-2.5 bg-slate-100 text-slate-700 text-xs font-bold rounded-xl hover:bg-slate-200 transition"
              >
                Copy Key
              </button>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t border-slate-100 flex items-center justify-between">
          {saved && (
            <span className="text-xs font-semibold text-emerald-600 flex items-center gap-1 animate-fadeIn">
              <Check className="w-4 h-4" /> Settings updated successfully!
            </span>
          )}
          <button 
            type="submit"
            className="ml-auto px-6 py-2.5 bg-indigo-600 text-white text-sm font-semibold rounded-xl hover:bg-indigo-700 transition shadow-md shadow-indigo-600/20"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}
